module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai_hiratsuka/ttl_msg-7e923549815cf3160172d05415578289.gif";